module.exports = __webpack_public_path__ + "8f84c3f7fa0fe16f984ce9858b77dbfd.pdf";